import { useMemo } from 'react';
import { AnimatePresence, motion } from 'motion/react';

import { useCarousel } from './hooks/useCarousel';
import { useGetParams } from './hooks/useGetParams';

import { MessagesList } from './components/MessagesList/MessagesList';

import defaultBackground from './assets/images/bg.png';

function App() {
  const { showedMessages, messagesRef, winnerMessage, speed, currentState } =
    useCarousel();

  const { bg, bgColor } = useGetParams();

  const background = useMemo(() => {
    return bg && bg !== '0'
      ? `url(${
          bg === '1' ? defaultBackground : bg
        }) center/cover no-repeat, ${bgColor}`
      : `none, ${bgColor}`;
  }, [bg]);

  return (
    <div
      className="app-wrapper"
      style={{ background, '--speed': `${speed}ms` }}
    >
      <AnimatePresence mode="wait">
        {['S1', 'S2', 'S3', 'S4'].includes(currentState) && (
          <div className="message-wrapper" key={'msgs'}>
            <motion.div
              initial={{ x: '-100%' }}
              animate={{ x: 0 }}
              transition={{ duration: 1 }}
              exit={{
                x: '-100%',
                transition: {
                  delay: 1,
                  duration: 0.5,
                },
              }}
              className="bgMotion"
            />

            <MessagesList
              winId={winnerMessage?.message.id}
              messages={showedMessages}
              currentState={currentState}
              speed={speed || 0}
              messagesRef={messagesRef}
            />
          </div>
        )}
      </AnimatePresence>

      <div id="img-loader" />
    </div>
  );
}

export default App;
